<template>
  <div class="top-layout-subscribe-banner">
    <div class="title">Подпишись на новые лекции Цифрового лектория.</div>

    <div class="button-wrapper">
      <a :href="telegramBotLink" class="button" target="_blank">
        <img src="~/assets/icons/telegram-btn.svg" alt="Icon telegram" />
      </a>

      <a :href="maxBotLink" class="button" target="_blank">
        <img src="~/assets/icons/max-btn.svg" alt="Icon max" />
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useCurrentDigitalLecture } from '~/composables/digital-lecture/use-digital-lecture-detail'
  import { useUserStore } from '~/store/user'

  const TELEGRAM_BOT_URL = 'https://t.me/konkurs_yavagro_bot'
  const MAX_BOT_URL = 'https://max.ru/ya_v_agro_bot'

  const img = useImage()
  const topUrl = `url(${img('/banners/top-layout/top.png', { format: 'webp' })})`

  const route = useRoute()
  const userStore = useUserStore()

  const lectureSlug = computed(() => {
    if (!route.path.startsWith('/digital-lecture/')) return null

    const slug = route.params.slug
    const value = Array.isArray(slug) ? slug[0] : slug

    return value || null
  })

  const currentLecture = useCurrentDigitalLecture()

  const isMounted = ref(false)
  onMounted(() => {
    isMounted.value = true
  })

  const videoPart = computed(() => {
    if (!isMounted.value) return ''

    const lecture = currentLecture.value
    const id = lecture && lecture.slug === lectureSlug.value ? lecture.id : null

    return id ? `_i${id}` : ''
  })

  const userPart = computed(() => {
    const id = userStore.user?.idShort

    return id ? `_u${id}` : ''
  })

  const telegramBotLink = computed(
    () => `${TELEGRAM_BOT_URL}?start=sub_dl${userPart.value}${videoPart.value}_pyvg`,
  )

  const maxBotLink = computed(
    () => `${MAX_BOT_URL}?start=sub_dl_pyvg${videoPart.value}${userPart.value}`,
  )
</script>

<style scoped lang="scss">
  .top-layout-subscribe-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: 62px;
    background-image: v-bind(topUrl);

    @include vp-1439 {
      padding: 10px;
    }
    @include vp-767 {
      height: 48px;
      padding: 10px;
    }

    > .title {
      font-weight: 600;
      font-size: 22px;
      line-height: 100%;
      text-transform: uppercase;
      color: $color-potato-90;

      @include vp-1439 {
        font-size: 20px;
        padding-right: 20px;
      }

      @include vp-767 {
        font-size: 14px;
        line-height: 16px;
      }
    }

    > .button-wrapper {
      display: flex;
      gap: 12px;

      > .button {
        width: 32px;
        height: 32px;
      }
    }
  }
</style>
